module.exports = __webpack_public_path__ + "static/media/1-2.01e7322e.mp3";